module.exports = __webpack_public_path__ + "static/active-barre-20222-0dd23935c518823e42128ef61bdbc7dc.jpg";